import {
    type_SET_SONG_INFO,
    type_SET_VIDEO_INFO,
    type_SET_PLAYER,
    type_SELECT_MV,
    type_SET_SEGMENT_AXIS,
    type_SET_SEGMENT_WH,
    type_SET_PLAYING_CURRENTTIME,
    type_SET_VIDEO_TRANSFORM,
    type_SET_SEGMENT_TIME,
    type_SET_PLAYING_STATE,
    type_SET_ACTION_REVERSE,
    type_SET_SEGMENT_WIDTH,
    type_SET_SEGMENT_SCALE
} from '../action/musicBgVideo';

const defaultSongInfo = {
    id: '',
    name: '',
    artists: '',
    coverImgUrl: '',
};

const defaultVideoState = {
    id: null,
    type: 1, // 1-mlog，2-MV，6-直播，0-视频（中转类型，可以通过视频 ID[加密] 获取对应 Mlog 详情）
    title: '',
    durationMs: 0,
    duration: 0,
    width: 0, // 原视频宽高
    height: 0,
    direction: 'horizontal', // vertical / horizontal => width>height h, otherwise v
    playCount: 0, // 播放次数
    starCount: 0, // 点赞数
    audioType: 0, // 视频是否有声音
    urlInfo: {
        url: null,
    },
    // 视频位置移动距离
    transform: {
        x: 0,
        y: 0
    }
};

// 视频裁剪的起始时间 截止时间 截取时长
// 1、视频类型 mlog/mv
// 2、视频ID
// 3、开始时间
// 4、结束时间
const defaultSegment = {
    resType: 1, // 定制资源类型，歌曲-1
    resId: null, // 资源id === songId？
    videoType: defaultVideoState.type, // === video.type mlog-1 mv-2
    videoId: defaultVideoState.id, // === video.id
    startTime: 0, // 默认从0开始
    endTime: 30, // 默认裁到30s
    timeLength: 30, // 默认选取30s
    width: 0, // 截取的视频宽高，非视频原宽高
    height: 0,
    x: 0, // 左上x坐标
    y: 0, // 左上y坐标
    unitType: 2, // 单位类型（1-绝对值，2-百分比）string
    segmentWidth: {
        l: 0, r: 0
    },
    scale: 1,
};

const defaultPlayerState = {
    playing: false,
    currentTime: defaultSegment.startTime, // 从startTime开始
    // api给出视频duration或者!==直接从videoRef上拿
    // duration: defaultSegment.timeLength,
};

const initState = {
    // song info 歌曲名，音乐人，歌曲封面
    songInfo: defaultSongInfo,
    // video info 视频地址 视频封面？ video元素的ref
    // videoRef: null,
    video: defaultVideoState, // 选中的视频
    segment: defaultSegment, // 视频选中的片段
    // player状态
    player: defaultPlayerState, // 播放相关state
    reverse: false // 正向为false 上一步反向为true
};

export default function mbgvReducer(state = initState, action) {
    const { type, payload } = action;
    switch (type) {
        case type_SELECT_MV:

            return {
                ...state,
                video: {
                    ...state.video,
                    ...payload,
                    duration: payload.durationMs / 1000
                },
            };
        case type_SET_PLAYING_STATE:
            return {
                ...state,
                player: { ...state.player, playing: payload },
            };
        case type_SET_PLAYING_CURRENTTIME:
            return {
                ...state,
                player: { ...state.player, currentTime: payload },
            };
        case type_SET_SONG_INFO:
            return {
                ...state,
                songInfo: {
                    ...state.songInfo,
                    ...payload,
                },
            };
        case type_SET_VIDEO_INFO:
            return {
                ...state,
                video: {
                    ...state.video,
                    ...payload,
                },
            };
        case type_SET_PLAYER:
            return {
                ...state,
                player: {
                    ...state.player,
                    ...payload,
                },
            };
        case type_SET_SEGMENT_AXIS:
            return {
                ...state,
                segment: {
                    ...state.segment,
                    ...payload, // x,y
                },
            };
        case type_SET_SEGMENT_WH:
            return {
                ...state,
                segment: {
                    ...state.segment,
                    ...payload, // width,height
                },
            };
        case type_SET_VIDEO_TRANSFORM:
            return {
                ...state,
                video: {
                    ...state.video,
                    transform: {
                        ...state.video.transform,
                        ...payload
                    }
                }
            };
        case type_SET_SEGMENT_TIME:
            return {
                ...state,
                segment: {
                    ...state.segment,
                    ...payload // startTime,endTime,timeLength
                }
            };
        case type_SET_ACTION_REVERSE:
            return {
                ...state,
                reverse: payload
            };
        case type_SET_SEGMENT_WIDTH:
            return {
                ...state,
                segment: {
                    ...state.segment,
                    segmentWidth: payload
                }
            };
        case type_SET_SEGMENT_SCALE:
            return {
                ...state,
                segment: {
                    ...state.segment,
                    ...payload // scale
                }
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./client/reducers/musicBgVideo.js